import React from 'react';
import { useSupabase } from '../contexts/SupabaseContext';
import { Database, Shield, AlertTriangle } from 'lucide-react';

const SupabaseConnectionStatus: React.FC = () => {
  const { isConnected } = useSupabase();

  if (isConnected) {
    return (
      <div className="fixed bottom-24 right-6 z-40 bg-green-100 text-green-800 px-4 py-2 rounded-lg shadow-lg flex items-center space-x-2">
        <Database className="h-5 w-5" />
        <span className="font-medium">Connected to Supabase</span>
      </div>
    );
  }

  return (
    <div className="fixed bottom-24 right-6 z-40 bg-red-100 text-red-800 px-4 py-2 rounded-lg shadow-lg flex items-center space-x-2">
      <AlertTriangle className="h-5 w-5" />
      <div>
        <p className="font-medium">Not connected to Supabase</p>
        <p className="text-xs">Click "Connect to Supabase" in the top right</p>
      </div>
    </div>
  );
};

export default SupabaseConnectionStatus;